import React from "react";
import { Col, Row, Label, Input } from "reactstrap";
import ImagePicker from "./ImagePicker";
import ImageCropper from "./ImageCropper";
import VideoPicker from "./VideoPicker";
import Switch from "react-switch";

export default function VariationForm(props) {
  const { variation } = props;
  const { hasInfluencer } = props;
  const { colorImage, pictures, videos, influencers } = variation;
  const [video = {}] = videos;

  function onImageCropped(image) {
    variation.colorImage = image;
    props.onChange(variation);
  }

  function changeColorName(e) {
    variation.colorName = e.target.value;
    props.onChange(variation);
  }

  function changeStock(index, value) {
    variation.stock[index].quantity = value;
    props.onChange(variation);
  }

  function onAddImage(index, image) {
    variation.pictures.splice(index, 1, image);
    props.onChange(variation);
  }

  function addVideoThumbnail(value) {
    variation.thumbnail = value;
    props.onChange(variation);
  }

  function addVideo(value) {
    variation.video = value;
    props.onChange(variation);
  }

  function changeHasInfluence(value) {
    props.onChangeHasInfluence(value);
  }

  function onAddImageInfluencer(index, image) {
    variation.influencers.splice(index, 1, image);
    props.onChange(variation);
  }

  return (
    <>
      <Row>
        <Col md={4}>
          <h4>Fotos</h4>
          <Row>
            <Col>
              <div style={{ height: 400 }}>
                <ImagePicker
                  onChange={(image) => onAddImage(0, image)}
                  defaultImage={pictures[0]}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={{ height: 170 }}>
                <ImagePicker
                  onChange={(image) => onAddImage(1, image)}
                  defaultImage={pictures[1]}
                />
              </div>
            </Col>
            <Col>
              <div style={{ height: 170 }}>
                <ImagePicker
                  onChange={(image) => onAddImage(2, image)}
                  defaultImage={pictures[2]}
                />
              </div>
            </Col>
            <Col>
              <div style={{ height: 170 }}>
                <ImagePicker
                  onChange={(image) => onAddImage(3, image)}
                  defaultImage={pictures[3]}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col>
              <h4>Vídeo</h4>
              <div style={{ height: 225 }}>
                <VideoPicker defaultVideo={video.url} onChange={addVideo} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <h4>Capa do vídeo</h4>
              <div style={{ height: 300 }}>
                <ImagePicker
                  onChange={addVideoThumbnail}
                  defaultImage={{ url: video.urlImage }}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <h4>Cor</h4>
          <Label>Nome da cor</Label>
          <Input value={variation.colorName} onChange={changeColorName} />
          <ImageCropper
            defaultImage={pictures[0] ? pictures[0].url : null}
            defaultCroppedImage={colorImage ? colorImage.url : null}
            texture={variation.colorImage}
            onImageCropped={onImageCropped}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h4>Influencer</h4>
          <Switch
            checked={hasInfluencer}
            onChange={checked => changeHasInfluence(checked)}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={18}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 7px rgba(0, 0, 0, 0.2)"
            height={12}
            width={28}
            className="react-switch mt-2"
            id="material-switch"
          />
        </Col>
      </Row>
      {!!hasInfluencer && (
        <Row>
          <Col>
            <div style={{ height: 300 }}>
              <ImagePicker
                onChange={(image) => onAddImageInfluencer(0, image)}
                defaultImage={influencers[0]}
              />
            </div>
          </Col>
          <Col>
            <div style={{ height: 300 }}>
              <ImagePicker
                onChange={(image) => onAddImageInfluencer(1, image)}
                defaultImage={influencers[1]}
              />
            </div>
          </Col>
          <Col>
            <div style={{ height: 300 }}>
              <ImagePicker
                onChange={(image) => onAddImageInfluencer(2, image)}
                defaultImage={influencers[2]}
              />
            </div>
          </Col>
        </Row>
      )}
      {/* <Row>
        <Col>
          <h4>Estoque</h4>
          <Row>
            {Array.isArray(variation.stock) && variation.stock.map((stock, index) => {
              return (
                <Label key={stock.size} sm={3} size="sm">
                  {stock.size}
                  <Input
                    type="number"
                    value={stock.quantity}
                    onChange={(e) => changeStock(index, Number(e.target.value))}
                  />
                </Label>
              );
            })}
          </Row>
        </Col>
      </Row> */}
    </>
  );
}
